import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import TripListTab from "./TripListTab";
import HistoryTab from "./HistoryTab";
import { NoAccess } from "../equipment/shared/NoAccess";

const ALLOWED_ROLES = ["Director", "Manager", "Back Office"];

export default function TransportLogPage() {
  const { user } = useAuth();
  const [active, setActive] = useState("trips");

  if (!ALLOWED_ROLES.includes(user?.role)) return <NoAccess />;

  return (
    <div className="space-y-6" data-testid="transport-log-page">
      <div>
        <h1 className="text-2xl font-bold tracking-tight text-slate-900" style={{ fontFamily: "Outfit, sans-serif" }}>
          Transport Log
        </h1>
        <p className="text-sm text-slate-500">Rig &amp; material trip tracking with live location updates.</p>
      </div>
      <Tabs value={active} onValueChange={setActive}>
        <TabsList>
          <TabsTrigger value="trips" data-testid="transport-tab-trips">
            Trip Register
          </TabsTrigger>
          <TabsTrigger value="history" data-testid="transport-tab-history">
            Location History
          </TabsTrigger>
        </TabsList>
        <TabsContent value="trips" className="pt-4">
          <TripListTab />
        </TabsContent>
        <TabsContent value="history" className="pt-4">
          <HistoryTab />
        </TabsContent>
      </Tabs>
    </div>
  );
}
